export default {
  MAIN_POPUP_HEIGHT: 423,
  MAIN_POPUP_WIDTH: 418
};
